import Box from '@mui/material/Box'
import {Text} from '../../1elements'

const ConfirmationMessage = ({selectedValuesObject}) => {
    const selectedValueList = () => (
        <div>
            {Object.keys(selectedValuesObject).map((selectedValueType)=>{
                const selectedValue = selectedValuesObject[selectedValueType] ? selectedValuesObject[selectedValueType] : ''
                return (
                    <Text key={selectedValueType} type={'dataExportConfirmation'}><span>{selectedValueType}</span> : {selectedValue}</Text>
                )
            })}
        </div>
    )

    return (
        <Box sx={{ marginBottom: '30px' }}>
            {selectedValueList()}
        </Box>
    )
}

export default ConfirmationMessage
